import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { allservicebooking } from '../../services/userServices'
import { RootState } from '../../store/store'

export interface ListOfServiceBooking {
  bookingid: number;
  bookingrefid?: string; // e.g., "refid1202511058546"
  customerid: number;
  userid?: number;
  technid: number;
  technician_name: string;
  bookingdate: string;
  slottype?: number; // 1 - Morning, 2 - Evening
  slot_name?: string;
  job_priority?: number;
  priority?: string;
  bookingstatus: string | number;
  bookingtype?: number; // 1 - Normal, 2 - Emergency
  model_name?: string;
  model?: string;
  vehicle_cat_name?: string;
  vehicle_subcat_name?: string;
  category?: string;
  sub_category?: string;
  servicecharges?: number;
  invoiceno: string;
  Description?: string;
  AMC_status?: any;
  issues?: string;
  vehicle_images?: string;
  service_booking_images?: string;
  service_booking_video?: string;
  comments?: string;
  created_date?: string;
  updated_date?: string;
}

// State type for the Redux slice
interface UserState {
  loading: boolean
  data: ListOfServiceBooking[]
  error: string | undefined
}

// Initial state for the Redux slice
const initialState: UserState = {
  loading: false,
  data: [],
  error: undefined
}

// Create a Redux slice
export const ListOfServiceBookingSlice = createSlice({
  name: 'bookedServices',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(allservicebooking.pending, (state) => {
      state.loading = true
      state.error = undefined
    })
    builder.addCase(
      allservicebooking.fulfilled,
      (state, action: PayloadAction<ListOfServiceBooking[]>) => {
        state.loading = false
        state.data = action.payload
        state.error = undefined
      }
    )
    builder.addCase(allservicebooking.rejected, (state, action) => {
      state.loading = false
      state.error =
        (action.payload as string | undefined) ||
        action.error.message ||
        'Failed to load service bookings'
    })
  }
})

// Selectors
export const ListOfServiceBookingSelector = (state: RootState): UserState => state.ListOfServiceBookingReducer
export default ListOfServiceBookingSlice.reducer
